import React from 'react'
import ReactGA from 'react-ga'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

export default class TicketingPlug extends React.Component { 

	handleTicketingPlug() { 
 		ReactGA.event({ 
 			category: 'User',
 			action: 'organizer_plug_click',
 			label: 'homepage'
 		})
 		window.location.href = "https://movement.launchaco.com/For%20Organizers"
	}


	render() { 
		return (<div style={{backgroundColor:'#f8f7fa', padding: 60}}>
					<div style={{textAlign:'center'}}>
				<h1 > Are you an organizer building experiences for the culture? </h1>
				<p > Learn how Movement Ticketing can help you showcase your dopeness, reach your target audience and grow </p>

				<Button variant="primary" style={{width:'40%'}}
				onClick={() => this.handleTicketingPlug()}>Learn more</Button>

				<Row style={{marginTop: 40, display: 'flex', justifyContent: 'center'}}>
					<Col>
						<img width="70" height="65" src="../static/8811.png"/>
					</Col>
					<Col>
						<img width="80" height="50" src="../static/queens.png"/>
					</Col>
					<Col>
						<img width="80" height="50" style={{marginRight:20}} src="../static/locals.png"/>
					</Col>
					<Col>
						<img width="80" style={{marginRight:20}} src="../static/soulful.png"/>
					</Col>
					<Col>
						<img width="50" src="../static/reparations.png"/>
					</Col>
					<Col>
						<img width="80" src="../static/lovejas.png"/>
					</Col>
				</Row>
		</div>
		</div>
		)
	}

}